var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { DateTime, Settings } from 'luxon';
import AlertBar from './components/AlertBar';
import AnimateHeight from 'react-animate-height';
var ANIMATION_DURATION = 600;
var LiveHearings = /** @class */ (function (_super) {
    __extends(LiveHearings, _super);
    function LiveHearings(props) {
        var _this = _super.call(this, props) || this;
        // Runs ONCE EVERY SECOND, keep it efficient!
        _this.checkHearings = function () {
            var shouldUpdate = false;
            var newState = __assign(__assign({}, _this.state), { nextHearing: null, liveHearing: null });
            _this.timeline.forEach(function (item) {
                var _a;
                var currentTime = Date.now();
                if (currentTime < item.start) {
                    newState.nextHearing = item.hearing;
                    shouldUpdate = true;
                }
                if (item.start < currentTime && currentTime < item.end) {
                    newState.liveHearing = item.hearing;
                    newState.showAlert = true;
                    shouldUpdate = true;
                }
                if (item.end < currentTime && ((_a = _this.state.liveHearing) === null || _a === void 0 ? void 0 : _a.uid) == item.hearing.uid) {
                    newState.liveHearing = null;
                    newState.liveEnded = item.hearing;
                    shouldUpdate = true;
                    // liveEnded state will last for timeout then get removed
                    var endingMessageDuration = 3000;
                    _this.closeAlert(endingMessageDuration);
                    setTimeout(function () {
                        var _a;
                        if (item.hearing.uid === ((_a = _this.state.liveEnded) === null || _a === void 0 ? void 0 : _a.uid))
                            _this.setState({ liveEnded: null });
                    }, endingMessageDuration + ANIMATION_DURATION);
                }
            });
            if (shouldUpdate) {
                _this.setState(newState);
            }
            ;
        };
        _this.createTimeline = function (hearings) {
            var timeline = [];
            hearings.forEach(function (hearing, index) {
                var startDateTime = DateTime.fromISO(hearing.livestartutctime || hearing.startutctime, { zone: _this.props.config.timezone });
                var endDateTime = DateTime.fromISO(hearing.liveendutctime || hearing.endutctime, { zone: _this.props.config.timezone });
                timeline[index] = {
                    hearing: hearing,
                    start: startDateTime.toMillis(),
                    end: endDateTime.toMillis(),
                };
            });
            return timeline;
        };
        _this.closeAlert = function (milliseconds) {
            if (milliseconds === void 0) { milliseconds = 0; }
            setTimeout(function () {
                _this.setState({ showAlert: false });
            }, milliseconds);
        };
        _this.getState = function () {
            return _this.state;
        };
        // Sets all uses of DateTime in this file to configured time zone
        Settings.defaultZone = props.config.timezone || '';
        _this.state = {
            showAlert: false,
            nextHearing: null,
            liveHearing: null,
            liveEnded: null,
        };
        _this.timeline = _this.createTimeline(props.upcomingHearings);
        Settings.defaultZone = 'system';
        return _this;
    }
    LiveHearings.prototype.componentDidMount = function () {
        var _this = this;
        this.ticker = setInterval(function () {
            _this.checkHearings();
        }, 1000);
    };
    LiveHearings.prototype.componentDidUpdate = function (_prevProps, prevState) {
        if (prevState.liveHearing !== this.state.liveHearing && this.state.liveHearing !== null) {
            // Add data-live-hearing <body> attribute for styling  and global reference
            document.body.dataset.liveHearing = this.state.liveHearing.uid;
            eventBus.dispatch("hearingUpdate", { state: this.state });
        }
        else if (prevState.liveEnded !== this.state.liveEnded && this.state.liveEnded == null) {
            delete document.body.dataset.liveHearing;
            eventBus.dispatch("hearingUpdate", { state: this.state });
        }
        else if (prevState.liveHearing !== this.state.liveHearing && this.state.liveHearing == null) {
            delete document.body.dataset.liveHearing;
            eventBus.dispatch("hearingUpdate", { state: this.state });
        }
    };
    LiveHearings.prototype.componentWillUnmount = function () {
        clearInterval(this.ticker);
    };
    LiveHearings.prototype.render = function () {
        var _a;
        var webroot = ((_a = window.application) === null || _a === void 0 ? void 0 : _a.webroot) || '/';
        var hearing = this.state.liveEnded || this.state.liveHearing;
        var hearingTime = (hearing === null || hearing === void 0 ? void 0 : hearing.startutctime) && DateTime.fromISO(hearing.startutctime, { zone: this.props.config.timezone });
        var userTime = (hearingTime) && hearingTime.setZone('system');
        var message;
        if (this.state.liveEnded) {
            message = (React.createElement("span", { className: "Text" }, "has ended."));
        }
        else if (this.state.liveHearing) {
            message = (React.createElement("span", { className: "Text Text--small" },
                hearingTime && " at ".concat(hearingTime.toFormat('hh:mma ZZZZ')),
                (hearingTime.zoneName !== userTime.zoneName) && React.createElement("em", null, " (".concat(userTime.toFormat('hh:mma ZZZZ'), ")"))));
        }
        return (React.createElement(AnimateHeight, { className: 'animate-height', duration: ANIMATION_DURATION, height: this.state.showAlert ? 'auto' : 0 },
            React.createElement(React.Fragment, null, (hearing) && (React.createElement(AlertBar, { prefix: 'Live', href: "".concat(webroot).concat(hearing.friendly_url) },
                React.createElement("span", { className: "bold", dangerouslySetInnerHTML: { __html: "".concat(hearing.fullTitlePrefix).concat(hearing.title, " ") } }),
                message)))));
    };
    return LiveHearings;
}(Component));
export { LiveHearings };
export var eventBus = {
    on: function (event, callback) {
        document.addEventListener(event, function (e) { return callback(e.detail); });
    },
    dispatch: function (event, data) {
        document.dispatchEvent(new CustomEvent(event, { detail: data }));
    },
    remove: function (event, callback) {
        document.removeEventListener(event, callback);
    },
};
window.setupLiveHearings = function (options) {
    ReactDOM.render(React.createElement(LiveHearings, { ref: function (liveHearings) { window.liveHearings = liveHearings; }, upcomingHearings: options.upcomingHearings, config: options.config || {} }), options.liveAlertContainer);
};
